import React, { useState, useEffect } from "react";

const AuthContext = React.createContext([{}, () => {}]);

// Load initial state from localStorage
let initialState = JSON.parse(localStorage.getItem("adminAuthState")) || {};

const AuthProvider = (props) => {
  const [state, setState] = useState(initialState);

  // Update localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem("adminAuthState", JSON.stringify(state));
  }, [state]);

  return (
    <AuthContext.Provider value={[state, setState]}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
